// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__16HDx","title":"Info_title__3Ag_r","selects":"Info_selects__3ySe0","requiredAsterisk":"Info_requiredAsterisk__2uISR"};